import {
  DeliveryContactTypeSchema,
  type DeliveryContactType as GeneratedDeliveryContactType
} from '~/services/api/generated'

// Mirrors backend App\Enums\Order\DeliveryContactType

export type DeliveryContactType = GeneratedDeliveryContactType

export const DeliveryContactType = {
  ME: DeliveryContactTypeSchema.enum.me,
  SOMEONE_ELSE: DeliveryContactTypeSchema.enum.someone_else
} satisfies Record<string, GeneratedDeliveryContactType>

export const DeliveryContactTypeValues: readonly GeneratedDeliveryContactType[] = [
  DeliveryContactTypeSchema.enum.me,
  DeliveryContactTypeSchema.enum.someone_else
]
